export const EducationProgramController = {
    index(): void {},
};
